import { InjectionToken } from '@angular/core';
import { SwiperOptions } from 'swiper/types';

import { SWIPER_BUILT_IN_THEMES } from '../components/swiper/swiper.themes';
import { SwiperThemes } from '../components/swiper/swiper.types';

/**
 * Global default `SwiperOptions` applied to every swiper before its theme and per-instance
 * options. Override globally via `provideSwiper({ options: { … } })` or per feature/route by
 * re-providing the token in the route's `providers` array.
 */
export const SWIPER_DEFAULT_OPTIONS = new InjectionToken<SwiperOptions>('SWIPER_DEFAULT_OPTIONS', {
    providedIn: 'root',
    factory: () => ({}),
});

/**
 * The registry of named swiper theme presets selectable via the `theme` input. Defaults to the
 * built-in themes; extend or replace via `provideSwiper({ themes: { … } })` or
 * `provideSwiperThemes({ … })`.
 */
export const SWIPER_THEMES = new InjectionToken<SwiperThemes>('SWIPER_THEMES', {
    providedIn: 'root',
    factory: () => SWIPER_BUILT_IN_THEMES,
});
